module.exports = __webpack_public_path__ + "img/CM.577a277d.svg";